import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { fetchCandidateTotalResumes } from "./CandidateActiveResumeBuilderAPI"

const initialState = {
    data: null, // store the full API response object
    loading: false,
    error: null,
}

export const fetchCandidateTotalResumesAsync = createAsyncThunk(
    "CandidateTotalResume",
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchCandidateTotalResumes()
            // Return the full response to maintain the structure
            return data
        } catch (error) {
            return rejectWithValue(error.message)
        }
    },
)

const CandidateTotalResumesSlice = createSlice({
    name: "CandidateTotalResume",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCandidateTotalResumesAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            // Fixed: Parameter order should be (state, action)
            .addCase(fetchCandidateTotalResumesAsync.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload
                state.error = null
            })
            // Fixed: Parameter order should be (state, action)
            .addCase(fetchCandidateTotalResumesAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload || action.error.message
            })
    },
})

// Updated selector to return the full state object for easier access
export const selectCandidateTotalResumes = (state) => state.CandidateTotalResume

export default CandidateTotalResumesSlice.reducer
